var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.shouldShowBanner)?_c('div',{staticClass:"u-pt-0 u-pb-20"},[_c('a',{attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.openClinicalEventsModal.apply(null, arguments)}}},[_c('img',{attrs:{"src":require("@/assets/images/clinical-training-banner.png"),"alt":""}})])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }